import RolePermissionManagementService, {
    initialiseRolesAndPermissions,
    getRdiUserRoles,
    getRdiUserPermissions,
    getRdiSystemRoles,
    getRdiSystemPermissions,
    userRolesCanActionResource,
    savePermission,
    saveRole,
    saveRolePermission,
    saveUserPermissions,
    getRdiSystemRolePermissionsByPermissionId,
    getRdiSystemRolePermissionsByRoleId,
    getRdiSystemRolePermissionsAll,
    removePermissionFromRole,
    removePermissionFromUser,
    saveUserRoles,
    removeRoleFromUser
} from './RolePermissionManagementService';

export default {
    RolePermissionManagementService,
    initialiseRolesAndPermissions,
    getRdiUserRoles,
    getRdiUserPermissions,
    getRdiSystemRoles,
    getRdiSystemPermissions,
    userRolesCanActionResource,
    savePermission,
    saveRole,
    saveRolePermission,
    saveUserPermissions,
    getRdiSystemRolePermissionsByPermissionId,
    getRdiSystemRolePermissionsByRoleId,
    getRdiSystemRolePermissionsAll,
    removePermissionFromRole,
    removePermissionFromUser,
    saveUserRoles,
    removeRoleFromUser
}